import type { BriefMedication, PatientBriefResponse } from "@/types/clinician";

export interface PrescriptionMedicationContext {
  prescriptionMedication: BriefMedication | null;
  otherActiveMedications: BriefMedication[];
}

/**
 * Keep the medication relevant to the selected work item visually separate
 * from the rest of the chart. The backend owns the exact product/tier match;
 * when the projection is absent during a rolling deploy, every legacy row is
 * conservatively treated as "other" instead of guessing by medication name.
 */
export function prescriptionMedicationContext(
  data: Pick<
    PatientBriefResponse,
    "medications" | "prescription_medication" | "other_active_medications"
  >,
): PrescriptionMedicationContext {
  const prescriptionMedication = data.prescription_medication ?? null;
  const otherActiveMedications =
    data.other_active_medications ??
    data.medications.filter(
      (medication) => medication.id !== prescriptionMedication?.id,
    );
  return { prescriptionMedication, otherActiveMedications };
}
